__turbopack_context__.v({
  "main": "MarketplacePostingNudgeCard-module-scss-module__vbXoHq__main",
  "textWrapper": "MarketplacePostingNudgeCard-module-scss-module__vbXoHq__textWrapper",
});
